import { render, staticRenderFns } from "./CartCounter.vue?vue&type=template&id=2d7db242&lang=pug&"
import script from "./CartCounter.vue?vue&type=script&lang=js&"
export * from "./CartCounter.vue?vue&type=script&lang=js&"
import style0 from "./CartCounter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports